import React from "react";
import { Redirect, Route, RouteProps, useParams } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import { ProtectedRouteProps } from "./ProtectedRoute.types";

const replaceParams = (path: string, params: Record<string, string>) => {
  for (const [key, value] of Object.entries(params)) {
    path = path.replaceAll(`:${key}`, value);
  }
  return path;
};

export function intersect(a: Array<any>, b: Array<any>) {
  const setB = new Set(b);
  return [...new Set(a)].filter(x => setB.has(x));
  //  return a.filter(Set.prototype.has, new Set(b)); possibly use this
}

export const ProtectedRoute: React.FC<ProtectedRouteProps & RouteProps> = ({
  permissions,
  children,
  siblings,
  ...props
}) => {
  const user = useAppSelector(state => state.auth.user);
  const Children = children as any;
  const params = useParams<any>();

  const render = () => {
    if (intersect(user.permissions, permissions).length) {
      return <Children />;
    } else {
      let path = "";
      if (typeof props.path === "string") {
        path = props.path.split("/").slice(0, -1).join("/") + "/";
      }
      //check if sibling is accessible for routing
      for (const route of siblings) {
        if (route.path) {
          if (route.permissions) {
            if (intersect(user.permissions, route.permissions).length) {
              return <Redirect to={replaceParams(path + route.path, params)} />;
            }
          } else {
            return <Redirect to={replaceParams(path + route.path, params)} />;
          }
        }
      }
      //if no sibling go back to where you came from
      return <Redirect to=".." />;
    }
  };
  return <Route {...props} render={render} />;
};
